import { useCoreLocations, useSelectedCoreLocationId } from '@elva/platform';

export function useLocationScope() {
  const locationId = useSelectedCoreLocationId();
  const { isLoading, isError, error } = useCoreLocations();

  return {
    locationId,
    isLocationReady: !isLoading && locationId !== undefined,
    isLocationLoading: isLoading,
    locationError: isError ? error : null,
  };
}
